import { observable, action, runInAction, computed } from 'mobx';

class ItemStore {
  constructor() {

  }

  init () {

  }

  /**
   * 控制 modal 是否显示
   */
  @observable
  is_modal_show = false;

  /**
   * 账户信息
   * @type {null}
   */
  @observable
  record = {};

  successHandle = null;

  /**
   * 打开 modal 显示
   */
  @action
  openModal(record,successHandle) {
    this.record = record;
    this.successHandle = successHandle;
    this.is_modal_show = true;
  }

  /**
   * 关闭 modal 显示
   */
  @action
  closeModal() {
    this.record = {};
    this.is_modal_show = false;
  }

  @action
  callSuccess(resultData){
    if (this.successHandle && typeof this.successHandle === 'function') {
      this.successHandle(resultData);
    }

    this.closeModal();
  }


}

let item_store = new ItemStore();
export default item_store;



// WEBPACK FOOTER //
// ./src/Store/Agent/AgentDetailPayStore.js